import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "u-magrinDataGrid" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Пользователи", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CatalogueGrid = _resolveComponent("CatalogueGrid")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ catalogue: !_ctx.selectMode })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_CatalogueGrid, {
        controller: 'User',
        columns: _ctx.columns,
        filterRowVisible: !_ctx.selectMode,
        groupPanelVisible: !_ctx.selectMode,
        headerFilterVisible: !_ctx.selectMode,
        filterPanelVisible: false,
        showPageSizeSelector: !_ctx.selectMode,
        pageSize: 10,
        pageSizes: _ctx.pageSizes,
        editingConfig: _ctx.editingConfig,
        selectionConfig: _ctx.selectionConfig,
        designConfig: _ctx.designConfig,
        getSelectedData: _ctx.getSelectedData,
        changeSelectedData: _ctx.changeSelectedData,
        popupCreateEditComponent: _ctx.userCreateEditDialog,
        selectMode: _ctx.selectMode,
        popupInfoComponent: _ctx.userInfoDialog
      }, null, 8, ["columns", "filterRowVisible", "groupPanelVisible", "headerFilterVisible", "showPageSizeSelector", "pageSizes", "editingConfig", "selectionConfig", "designConfig", "getSelectedData", "changeSelectedData", "popupCreateEditComponent", "selectMode", "popupInfoComponent"])
    ])
  ], 2))
}